import { isAQuery } from '@jupiterone/jupiter-web-toolkit';
import { DeferredQueryInput } from '@jupiterone/jupiter-web-toolkit/src/hooks/graphql/useDeferredJ1QLQuery';
import { QueryOutput } from './useSearchAnywhereContainerLogic';

const formatQuery = (query: string) => {
  const trimmedSearchQuery = query.trim();
  return isAQuery(trimmedSearchQuery)
    ? trimmedSearchQuery
    : `"${trimmedSearchQuery}"`;
};

const j1QueryToQueryOutput = (query: DeferredQueryInput): QueryOutput => {
  return {
    type: 'query',
    query: {
      ...query,
      query: formatQuery(query.query),
    },
    runTimestamp: new Date().getTime(),
  };
};

export default j1QueryToQueryOutput;
